import { Component, OnInit, } from "@angular/core";
import { AutenticacaoService } from '../services/autenticacao.service';
import { Router } from '@angular/router';
import { CarregandoService } from "../services/carregando.service";
import { GlobalService } from "../services/global.service";
import { CacheService } from "../services/cache-service";
import { MatDialog } from "@angular/material/dialog";

@Component({
  selector: "app-login-gi",
  templateUrl: "./logout.component.html",
  styleUrls: ["./logout.component.scss"],
})
export class LogoutComponent implements OnInit {
  constructor(
    private carregandoService: CarregandoService,
    private autenticacaoService: AutenticacaoService,
    private globalService: GlobalService,
    private cacheService: CacheService,
    public dialog: MatDialog,
    private router: Router
  ) {}

  async ngOnInit() {
    this.carregandoService.mostra("logout");

    await this.autenticacaoService
      .logout()
      .toPromise()
      .then(() => {})
      .finally(() => {
        this.cacheService.clearCachedResponse();
        this.dialog.closeAll();

        this.globalService.limparUsuarioAtual();
        this.autenticacaoService.logoutLocal();

        this.carregandoService.zera();
        this.carregandoService.esconde("logout");

        this.router.navigate(["/login"]);
      });
  }
}

